import {
    getPrevAssessmentResponses,
    retakeAssessment,
    checkLanguageSubmission
} from "../../services/svt/svt-user";
import { useContext, useState } from "react";

import { SVTUserContext } from "../../utils/SVTUserContext";
import Loader from "../common/Loader/Loader";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const TemplateTile = ({ tile, templateData, sasToken }) => {
    const { t } = useTranslation();
    const { templateMasterName, imageUri, templateMasterId } = tile;
    const [loading, setLoading] = useState(false);
    const {
        selectedEntity,
        setActiveLevelId,
        assessmentId,
        setAssessmentId,
        setTemplateName,
        setActiveTab,
        setIsSave,
        setAssessmentResponses,
        setScores,
    } = useContext(SVTUserContext);

    const [isModalOpen, setIsModalOpen] = useState(false);
     const languageMap = {
        en: 1,
        ch: 19,
        jp: 2
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        setScores({
            basicScore: 0,
            developingScore: 0,
            matureScore: 0,
            aggregateScore: 0,
        });
    };

    const handleModalConfirm = () => {
        setIsModalOpen(false);
        if (assessmentId && selectedEntity) {
            confirmRetakeAssessment();
            setAssessmentResponses([]);
            setActiveTabAndId([]);
            setLevelScores([]);
        }
    };

    const confirmRetakeAssessment = async () => {
        try {
            const res = await retakeAssessment(
                assessmentId,
                1,
                selectedEntity,
                languageMap[sessionStorage.getItem("selectedLanguage") || "en"]
            );
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const fetchData = async (assessmentId) => {
        try {
            const res = await getPrevAssessmentResponses(
                assessmentId,
                1,
                selectedEntity,
                languageMap[sessionStorage.getItem("selectedLanguage") || "en"]
            );
            setAssessmentResponses(res?.data || []);
            setActiveTabAndId(res?.data || []);
            setLevelScores(res?.data || []);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const setActiveTabAndId = (prevResponseData) => {
        if (prevResponseData.length > 0) {
            const savedResponse = prevResponseData.find(
                (item) => item.isSubmitted === false
            );
            const maxLevelItem = savedResponse
                ? savedResponse
                : prevResponseData[0];
            if (maxLevelItem?.isSubmitted === false) {
                setActiveLevelId(maxLevelItem?.levelId);
                setActiveTab("Tab3");
                setIsSave(true);
            } else if (
                maxLevelItem?.scorePercentage === 100 &&
                maxLevelItem?.levelId < 3
            ) {
                setActiveTab("Tab4");
                setActiveLevelId(maxLevelItem.levelId);
            } else if (maxLevelItem?.aggregateScore === 100) {
                setIsModalOpen(true);
            } else {
                setActiveLevelId(maxLevelItem?.levelId);
                maxLevelItem?.levelId > 1
                    ? setActiveTab("Tab4")
                    : setActiveTab("Tab3");
            }
        } else {
            setActiveLevelId(1);
            setActiveTab("Tab3");
        }
    };

    const setLevelScores = (prevResponseData) => {
        if (prevResponseData.length > 0) {
            setScores((prevState) => ({
                ...prevState,
                aggregateScore: prevResponseData[0].aggregateScore,
            }));
            prevResponseData.map((response) => {
                if (response.levelId === 1) {
                    if (response.isSubmitted)
                        setScores((prevState) => ({
                            ...prevState,
                            basicScore: response.scorePercentage,
                        }));
                    else
                        setScores((prevState) => ({
                            ...prevState,
                            basicScore: -1,
                        }));
                } else if (response.levelId === 2) {
                    if (response.isSubmitted)
                        setScores((prevState) => ({
                            ...prevState,
                            developingScore: response.scorePercentage,
                        }));
                    else
                        setScores((prevState) => ({
                            ...prevState,
                            developingScore: -1,
                        }));
                } else if (response.levelId === 3) {
                    if (response.isSubmitted)
                        setScores((prevState) => ({
                            ...prevState,
                            matureScore: response.scorePercentage,
                        }));
                    else
                        setScores((prevState) => ({
                            ...prevState,
                            matureScore: -1,
                        }));
                }
            });
        } else
            setScores({
                basicScore: 0,
                developingScore: 0,
                matureScore: 0,
                aggregateScore: 0,
            });
    };

    const checkLanguageSubmissionAssessment = async (templateMasterId) => {
        try {
            const res = await checkLanguageSubmission(
                templateMasterId,
                selectedEntity,
                languageMap[sessionStorage.getItem("selectedLanguage") || "en"]
            );
            return res?.data;
        } catch (error) {
            console.error("Error checking language submission:", error);
        }
    };

    const onTileClick = async (templateMasterName) => {
        setLoading(true);
        setTemplateName(templateMasterName);
        if (templateData?.length > 0) {
            const template = templateData.find(
                (template) => template.templateMasterName === templateMasterName
            );
            if (template && selectedEntity) {
                const isSubmitted = await checkLanguageSubmissionAssessment(templateMasterId);
                if (isSubmitted === false) {
                    const assessmentId = template.assessmentId;
                    assessmentId && selectedEntity && fetchData(assessmentId);
                    setAssessmentId(assessmentId);
                    setLoading(false);
                } else {
                    toast.info(t("languageSubmissionFoundForAssessment"));
                    setLoading(false);
                }
            }else{
                toast.info(t("selectEntity"));
                setLoading(false);
            }
        }
    };
    return (
        <>
            {loading && <Loader />}
            <div key={tile.templateMasterId} className="tile col-sm-4 col-md-4 col-lg-4">
                <button
                    className="tile-content"
                    onClick={() => onTileClick(templateMasterName)}
                >
                <img
                    src={imageUri + "?" + sasToken}
                    alt={templateMasterName}
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                    }}
                />
            </button>
            <div className="tile-label">{templateMasterName}</div>
            {isModalOpen && (
                <div className="submit-modal">
                    <div className="submit-modal-content">
                        <h3>{t("restartAssessment")}</h3>
                        <h4 style={{ color: "red" }}>
                            {t("restartAssessmentWarning")}
                        </h4>
                        <div className="submit-modal-buttons">
                            <button
                                className="cancelButton"
                                onClick={handleModalClose}
                            >
                                {t("cancel")}
                            </button>
                            <button
                                className="saveButton"
                                onClick={handleModalConfirm}
                            >
                                {t("confirm")}
                            </button>
                        </div>
                    </div>
                </div>
            )}
             </div>
        </>
    );
};

export default TemplateTile;
